/*
	Intercepts copy events and corrects clipboard text for elements marked with
	a specific data attribute. 
	
	The truncated component uses CSS grid which adds newlines to the clipboard when the element
	is serialised. This function replaces the truncated children with their text content.
*/
export function handleClipboardOverride(selector: string, doc: Document, event: ClipboardEvent): void {
	const selection = doc.getSelection();

	if (!selection || selection.isCollapsed || selection.rangeCount === 0) {
		return;
	}

	const container = doc.createElement("div");
	container.appendChild(selection.getRangeAt(0).cloneContents());

	const elements = container.querySelectorAll(selector);

	for (const element of elements) {
		element.replaceChildren(element.textContent);
	}

	doc.body.appendChild(container);

	event.preventDefault();
	event.clipboardData?.setData("text/plain", container.innerText);

	doc.body.removeChild(container);
}
